export default __webpack_public_path__ + "static/way-forward-single-banner-26cbb13b31bdc6a9e4455ffa9820c04d.jpg";